import { c as _c } from "react/compiler-runtime";
// Full-bleed raster background for an `<OgShell>` variant.

import { OgImage } from '../../primitives/og-image';
import type { OgShellVariant } from '../../registry';
import { OG_DIMENSIONS, OG_TOKENS } from '../../tokens';
import { getShellBackgroundUrl } from '../__internal__/shell-background-src';
interface OgShellBackgroundProps {
  variant: OgShellVariant;
}
export function OgShellBackground(t0) {
  const $ = _c(5);
  const {
    variant
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      position: "absolute",
      top: 0,
      left: 0,
      width: OG_DIMENSIONS.width,
      height: OG_DIMENSIONS.height,
      display: "flex",
      overflow: "hidden"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== variant) {
    t2 = getShellBackgroundUrl(variant);
    $[1] = variant;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div style={t1}><OgImage src={t2} alt="" width={OG_DIMENSIONS.width} height={OG_DIMENSIONS.height} fit="cover" fallbackBackground={OG_TOKENS.brand700} /></div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}